import { asyncAction, action } from 'lib/actions';

export const fetchSubstratesAction = asyncAction('substrates/FETCH');
export const setCommonSubstratesAction = action('substrates/SET_COMMON');
